
import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import GiftsReportsListView from "./gifts_reports-list.html";

angular.module("gifts_reports", [])

    .config(['$stateProvider' ,function ($stateProvider) {
        $stateProvider
            .state('gifts_reports', {
                url: "/gifts_reports",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
                data: { pageTitle: "Informes de Regalos" }
            })
            .state('gifts_reports.list', {
                url: "/list",
                controller: "GiftsReportsCtrl",
                template: GiftsReportsListView,
                data: { pageTitle: "Informes de Regalos" }
            })            
        ;
    }])
;